import React from "react";

export default function VideoInput(props) {
    const { width, height } = props;

    const inputRef = React.useRef();

    const [source, setSource] = React.useState();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const url = URL.createObjectURL(file);
        setSource(url);
        props.setSource(event, url);
    };

    const handleChoose = (event) => {
        inputRef.current.click();
    };

    return (
        <div className="row justify-content-center m-0 w-100">
            <div className="VideoInput">
                <input
                    ref={inputRef}
                    className="VideoInput_input"
                    type="file"
                    onChange={handleFileChange}
                    accept=".mov,.mp4"
                    aria-label="kkkk"
                />
                {/* {!source && <button onClick={handleChoose}>انتخاب</button>} */}
                {source && (
                    <video
                        aria-label="kkkk"
                        className="VideoInput_video"
                        width="100%"
                        height={height}
                        controls
                        src={source}
                    />
                )}
            </div>
        </div>
    );
}
